import React, { useCallback, useMemo } from "react";
import { useStores } from "@client/store";
import { observer } from "mobx-react-lite";
import { Typography, useTheme } from "@ugc-ui/lego";
import { ListItem } from "@common/components/Drawer/ListItem/ListItem";
import { IconsName } from "@ugc-ui/lego/components/Icon/Icon.types";
import { ConfirmActionModalType } from "@common/components/Modal/ConfirmActionModal/ConfirmActionModal.utils";
import { Drawer } from "@common/components/Drawer/Drawer";
import { DrawerTemplateDefault } from "@common/components/Drawer/DrawerTemplate/DrawerTemplateDefault/DrawerTemplateDefault";
import { DrawerUploadVieoMenuContainer } from "./DrawerUploadVideoMenu.styled";

type Props = {
  uploadAreaDetach: () => void;
};

export const DrawerUploadVideoMenu: React.FC<Props> = observer(
  ({ uploadAreaDetach }) => {
    const theme = useTheme();

    const {
      videoUploadVideoDrawer: { isOpen, closeDialog },
      exitModalStore: { openDialogAndAttach },
      videoPlayerModal: { closeDialog: closeVideoPlayerModal },
    } = useStores();

    const handleOnUploadVideoDelete = useCallback(() => {
      openDialogAndAttach({
        type: ConfirmActionModalType.DELETE,
        applyCallback: () => {
          uploadAreaDetach();
          closeVideoPlayerModal();
        },
      });
      closeDialog();
    }, [
      closeDialog,
      closeVideoPlayerModal,
      openDialogAndAttach,
      uploadAreaDetach,
    ]);

    const menuItems = useMemo(() => {
      return [
        {
          title: "Удалить",
          handleOnClick: handleOnUploadVideoDelete,
          icon: "bin",
          color: theme.error.main,
        },
      ];
    }, [handleOnUploadVideoDelete, theme.error.main]);

    const menuItemsRender = menuItems.map((item) => (
      <ListItem
        key={item.title}
        onClick={item.handleOnClick}
        endIcon={item.icon as IconsName}
        dataCy={`дравер-кнопка-${item.title}`}
        color={item?.color}
      >
        <Typography type="body2" color={item.color}>
          {item.title}
        </Typography>
      </ListItem>
    ));

    return (
      <Drawer
        isOpen={isOpen}
        onRequestClose={() => closeDialog()}
        dataCy="дравер меню загрузки видео"
      >
        <DrawerTemplateDefault onClose={() => closeDialog()}>
          <DrawerUploadVieoMenuContainer>
            {menuItemsRender}
          </DrawerUploadVieoMenuContainer>
        </DrawerTemplateDefault>
      </Drawer>
    );
  }
);
